var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlueCard',[_c('SurveySessionsTable',{attrs:{"data":_vm.data,"loading":_vm.loading,"viewHistoric":_vm.viewHistoric},on:{"view-historic-clicked":_vm.updateScope}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }